<template>
  <div v-loading="loading">
    <div v-if="editModel">
      <el-form
        ref="form"
        :size="$xUISize"
        :model="editModel"
        :rules="editRules"
        @submit.native.prevent
        label-width="auto"
        label-position="top"
      >
        <el-card shadow="hover" style="margin-bottom: 12px">
          <div style="padding: 5px 20px">
            <div class="goods-form-title">
              <span>基础属性</span>
            </div>
            <el-form-item label="组合标题" prop="title" key="title">
              <el-input placeholder="请输入组合标题" v-model="editModel.title"></el-input>
            </el-form-item>
          </div>
        </el-card>

        <el-card shadow="hover" style="margin-bottom: 12px">
          <div style="padding: 10px 20px">
            <div class="goods-form-title">
              <span>由以下商品组合</span>
            </div>
            <el-form-item label="组合清单" prop="itemList">
              <div>
                <goods-sku-select :multipleable="true" :excludeGuids="itemExcludeGuids">
                  <template slot="info-append" slot-scope="scope">
                    <div style="margin-top: 10px">
                      <template v-if="getItemBySkuGuid(scope.info.guid)">
                        <el-input-number
                          v-model="getItemBySkuGuid(scope.info.guid).skuCount"
                          style="width: 120px; margin-right: 10px"
                          size="small"
                          :min="1"
                        >
                        </el-input-number>
                        <el-button
                          size="small"
                          type="danger"
                          @click="removeItemClick(getItemBySkuGuid(scope.info.guid))"
                        >
                          移出清单
                        </el-button>
                      </template>
                      <template v-else>
                        <el-button
                          size="small"
                          type="primary"
                          @click="handleAddItem(scope.info)"
                        >
                          添加到清单
                        </el-button>
                      </template>
                    </div>
                  </template>
                </goods-sku-select>
                <el-table
                  stripe
                  v-if="editModel.itemList && editModel.itemList.length > 0"
                  :data="editModel.itemList"
                  :cell-class-name="itemDelLine"
                  :size="$xUISize"
                  style="width: 100%; margin-top: 10px"
                >
                  <el-table-column label="商品信息" min-width="380px">
                    <template slot-scope="scope">
                      <div style="margin-right: 10px">
                        <goods-sku-info :skuInfo="scope.row.skuInfo" />
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column label="数量" width="180px">
                    <template slot-scope="scope">
                      <el-input-number
                        :disabled="!!scope.row.isDelete"
                        v-model="scope.row.skuCount"
                        style="width: 120px; margin-right: 10px"
                        size="small"
                        :min="1"
                      >
                      </el-input-number>
                    </template>
                  </el-table-column>
                  <el-table-column label="操作" width="120px">
                    <template slot-scope="scope">
                      <el-button
                        size="mini"
                        type="danger"
                        v-if="!scope.row.guid"
                        @click="removeItemClick(scope.row)"
                      >
                        移出
                      </el-button>
                      <el-link
                        v-if="scope.row.guid"
                        :type="scope.row.isDelete ? 'primary' : 'danger'"
                        :underline="false"
                        @click="deleteItemClick(scope.row)"
                      >
                        {{ scope.row.isDelete ? "取消删除" : "标记删除" }}
                      </el-link>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </el-form-item>
          </div>
        </el-card>
        <el-card shadow="hover">
          <div style="padding: 10px 20px">
            <el-form-item>
              <el-button
                type="primary"
                :loading="editSubmit"
                @submit.native.prevent
                @click="submitClick"
              >
                保存
              </el-button>
            </el-form-item>
          </div>
        </el-card>
      </el-form>
    </div>
    <el-card v-else-if="!loading" shadow="hover">
      <el-empty :description="errorMsg" :image-size="100">
        <el-button v-if="errorMsg" @click="fetchModel" size="small"> 重新加载 </el-button>
      </el-empty>
    </el-card>
  </div>
</template>

<style lang="less" scoped>
.borderBox {
  border-radius: 4px;
  border: 1px solid #dedede;
  padding: 20px;

  &:hover {
    border: 1px solid #cecece;
  }
}

.goods-form-title {
  color: #919191;
  margin-bottom: 10px;
  font-size: 16px;
}
</style>

<script>
import GoodsSkuInfo from "../../../../components/business/goodsSkuInfo.vue";
import GoodsSkuSelect from "../../../../components/business/goodsSkuSelect.vue";

const defaultModel = {
  title: "",
  itemList: [],
};

export default {
  components: {
    GoodsSkuSelect,
    GoodsSkuInfo,
  },
  props: {
    params: {
      type: Object,
      default: () => ({}),
    },
    query: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    itemExcludeGuids() {
      let guids = [];
      if (this.editModel && this.editModel.itemList) {
        guids.push(
          ...this.editModel.itemList
            .filter((item) => {
              return !item.skuGuid;
            })
            .map((i) => {
              return i.skuGuid;
            })
        );
      }
      return guids;
    },
    pageParams() {
      return Object.assign({}, (this.$route && this.$route.params) || {}, this.params);
    },
    pageQuery() {
      return Object.assign({}, (this.$route && this.$route.query) || {}, this.query);
    },
  },
  data() {
    return {
      loading: false,
      errorMsg: null,
      editSubmit: false,
      editModel: null,
      editRules: {
        title: [
          {
            required: true,
            message: "请输入标题",
            trigger: "change",
          },
        ],
      },
    };
  },
  methods: {
    itemDelLine({ row, column, rowIndex, columnIndex }) {
      if (row.isDelete) return "del_line";
    },
    removeItemClick(row) {
      if (!this.editModel.itemList) {
        this.editModel.itemList = [];
      }
      let indexOf = -1;
      this.editModel.itemList.forEach((i, index) => {
        if (row.skuInfo && row.skuInfo.guid == i.skuGuid) {
          indexOf = index;
        } else if (row.guid == i.skuGuid) {
          indexOf = index;
        }
      });
      if (indexOf >= 0) {
        this.editModel.itemList.splice(indexOf, 1);
      }
    },
    deleteItemClick(item) {
      item.isDelete = item.isDelete ? 0 : 1;
    },
    getItemBySkuGuid(skuGuid) {
      let findItem;
      (this.editModel.itemList || []).forEach((item) => {
        if (item.skuGuid == skuGuid) {
          findItem = item;
        }
      });
      return findItem;
    },
    handleAddItem(item) {
      if (!this.editModel.itemList) {
        this.editModel.itemList = [];
      }
      let flag = false;
      this.editModel.itemList.forEach((i) => {
        if (item.skuInfo && item.skuInfo.guid == i.skuGuid) {
          flag = true;
        } else if (i.skuGuid == item.guid) {
          flag = true;
        }
      });
      if (!flag) {
        this.editModel.itemList.unshift({
          skuInfo: item,
          skuGuid: item.guid,
          skuCount: 1,
          isDelete: 0,
        });
      }
    },
    submitClick() {
      return new Promise((resolve, reject) => {
        if (!this.$refs.formRef) {
          resolve();
        } else {
          this.$refs.formRef.validate((valid, data) => {
            if (valid) {
              resolve();
            } else {
              this.showValidate(data);
              reject();
            }
          });
        }
      }).then(() => {
        this.$refs.form.validate((valid, data) => {
          if (valid) {
            this.editSubmit = true;
            const method = this.editModel.guid
              ? "biz.goods.combination.info.update"
              : "biz.goods.combination.info.create";
            this.requestApi(method, this.editModel, {
              showError: true,
            })
              .then((resp) => {
                this.success("保存成功");
                this.$drawer.refreshDrawer();
                this.$drawer.backDrawer();
              })
              .finally(() => {
                this.editSubmit = false;
              });
          } else {
            this.showValidate(data);
          }
        });
      });
    },
    handleModel() {
      // nothing
      this.fetchItemList();
    },
    fetchItemList() {
      if (this.editModel && this.editModel.guid) {
        return this.requestApi("biz.goods.combination.item.list", {
          combinationGuid: this.editModel.guid,
        }).then((listResp) => {
          this.editModel.itemList = (listResp.data.list || []).map((item) => {
            item.isDelete = 0;
            return item;
          });
        });
      } else {
        this.editModel.itemList = [];
      }
    },
    fetchModel() {
      const guid = this.pageParams.guid;
      if (!guid) {
        // 新增
        this.editModel = Object.assign({}, defaultModel);
        this.handleModel();
      } else {
        // 编辑
        this.errorMsg = null;
        this.loading = true;
        this.requestApi("biz.goods.combination.info.detail", {
          guid: this.pageParams.guid,
        })
          .then((resp) => {
            this.editModel = Object.assign({}, defaultModel, resp.data);
            this.handleModel();
          })
          .catch((err) => {
            this.errorMsg =
              (err && err.msg) || (err && err.message) || "连接服务器失败，请检查网络";
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
  },
  mounted() {
    this.fetchModel();
  },
};
</script>
